var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterForceDescent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.59 33h-40l5-6h39.82l-4.82 6zm4.81 4H9.59l-5 6h40l4.81-6zm0 10H9.59l-5 6h40l4.81-6zm0 10H9.59l-5 6h40l4.81-6zM27 20L37.93 9H16.07L27 20zm45 12.39c0 3.65-2.5 6.8-5.1 8.76v7.65l-2.79 2.51 2.77 3.17-2.77 2.7 2.74 3.36L63 65l-3.91-4.45V40.82A9.22 9.22 0 1172 32.39zm-7.52-3.73a2.21 2.21 0 10-4.42 0 2.21 2.21 0 004.42 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_force_descent.15869bf4.svg";
export { SvgC1RollerShutterForceDescent as ReactComponent };